import EditArtwork from './EditArtwork';

export default EditArtwork;
